import { Fragment, useEffect, useState } from "react";
import { ChevronDown } from "react-feather";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Collapse
} from "reactstrap";
import { Btn, H4, H6, Image, P, Spinner } from "AbstractElements";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setFilters } from "Features/Learning/CategoryProgram/categoryProgramSlice";
import { setField } from "Features/Learning/CategoryProgram/addCategoryProgramSlice";
import PaginationComponent from "../Common/Pagination";
import {
  fetchCategory,
  handleEditCategoryProgram,
  handleDeleteCategoryProgram,
  handleBackPagination,
  handleNextPagination,
  handleClickPagination,
} from "./CategoryProgramUtils";
import DualListBoxCategory from "../Common/DualListBoxCategory";
import Moment from "moment";

const CategoryProgramProgramContain = () => {
  const [isActivity, setIsActivity] = useState([]);
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.CategoryProgram.filters);
  const isLoading = useSelector((state) => state.CategoryProgram.isLoading);
  const cards = useSelector((state) => state.CategoryProgram.data.data);
  const pagination = useSelector((state) => state.CategoryProgram.data.pagination);
  const [refatch, setRefatch] = useState(false);

  const handleChange = (e) => {
    let collapseCopy = [...isActivity];
    collapseCopy[e] = !collapseCopy[e];
    setIsActivity(collapseCopy);
  };

  useEffect(() => {
    fetchCategory(dispatch, filters, refatch);
  }, [refatch]);

  const cardHeader = (item) => {
    return (
      <CardHeader style={{ marginRight: "15px", padding: "8px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              attrImage={{
                className: "rounded-circle img-40",
                src: `${item.icon}`,
                alt: "",
              }}
            />
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center"
                }}>
                <H6 attrH6={{ className: "m-0" }}>{item.id}</H6> &nbsp; - &nbsp;
                <H6 attrH6={{ className: "m-0" }}>{item.name}</H6>
              </div>
              <P attrPara={{ className: "mb-0 text-muted ms-3" }}>
                Update pada: {Moment(item.updated_at).format("DD/MM/YYYY")} &nbsp; &nbsp;
              </P>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {(item?.children?.length > 0) && (
              <Btn
                attrBtn={{
                  color: "ps-0",
                  onClick: () => handleChange(item.id),
                  datatoggle: "collapse",
                  datatarget: `#collapseicon${item.id}`,
                  ariaexpanded: "true",
                  ariacontrols: `collapseicon${item.id}`,
                  style: {
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  },
                }}>
                <ChevronDown />
              </Btn>
            )}
            {
              (item?.children?.length > 0) && (
                <>
                  <DualListBoxCategory datas={item} />
                  <Link
                    to={`/category-program/add/${item.id}`}
                    onClick={() => handleEditCategoryProgram(dispatch, item, setField)}>
                    <Btn
                      attrBtn={{
                        color: "link",
                        outline: true,
                        className: "p-1",
                      }}>
                      <i className="fa fa-pencil mx-auto"></i>
                    </Btn>
                  </Link>
                  <Btn
                    attrBtn={{
                      color: "link",
                      outline: true,
                      className: "p-1",
                      onClick: () =>
                        handleDeleteCategoryProgram(dispatch, item.id, setRefatch),
                    }}>
                    <i className="fa fa-trash-o mx-auto text-danger"></i>
                  </Btn>
                </>
              )}
          </div>
        </div>
      </CardHeader>
    );
  };

  return (
    <>
      {isLoading ? (
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: "loader-30" }} />
          </div>
          <H6 attrH6={{ className: "sub-title mb-0 text-center" }}>
            {"Data Loading..."}
          </H6>
        </Col>
      ) : (
        <Col lg="12">
          <Row
            className="row default-according style-1 faq-accordion"
            id="accordionoc">
            <Col xl="12" lg="6">
              {cards &&
                cards?.map((item) => {
                  // if (item?.is_parent === 1) {
                  return (
                    <Card key={`category-${item?.id}`}>
                      {cardHeader(item)}
                      <Collapse isOpen={isActivity[item?.id]}>
                        <CardBody>
                          {item?.children &&
                            item?.children?.map((child) => {
                              return (
                                <Fragment key={child?.id}>
                                  {cardHeader(child)}
                                </Fragment>
                              );
                            })}
                        </CardBody>
                      </Collapse>
                    </Card>
                  );
                  // }
                })}
            </Col>
          </Row>
        </Col>
      )}
      {!cards ||
        (cards.length === 0 && (
          <Col lg="12">
            <H4 attrH4={{ className: "sub-title mb-5 text-center" }}>
              {!cards ? "Sumber Data Tidak Tersedia" : "Data Tidak Ditemukan"}
            </H4>
          </Col>
        ))}

      {isLoading === false && cards && cards.length > 0 && pagination && (
        <CardBody>
          <PaginationComponent
            pagination={pagination}
            handleBackPagination={() =>
              handleBackPagination(
                pagination,
                filters,
                dispatch,
                setFilters,
                setRefatch
              )
            }
            handleClickPagination={(page) =>
              handleClickPagination(
                page,
                filters,
                dispatch,
                setFilters,
                setRefatch
              )
            }
            handleNextPagination={() =>
              handleNextPagination(
                pagination,
                filters,
                dispatch,
                setFilters,
                setRefatch
              )
            }
          />
        </CardBody>
      )}
    </>
  );
};
export default CategoryProgramProgramContain;
